// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_r8-0";